'use client';

import { Quote } from 'lucide-react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { RichText } from '@/components/shared/RichText';

interface TestimonialCarouselProps {
  testimonials: any[];
}

export function TestimonialCarousel({ testimonials }: TestimonialCarouselProps) {
  return (
    <Carousel
      opts={{
        align: "start",
        loop: true,
      }}
      className="w-full"
    >
      <CarouselContent className="-ml-4">
        {testimonials.map((item) => (
          <CarouselItem key={item.id} className="pl-4 md:basis-1/2 lg:basis-1/3">
            <div className="h-full bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-light flex flex-col justify-between relative group hover:shadow-xl transition-all duration-500">
              <div className="absolute top-8 right-8 text-primary/10 group-hover:text-primary/20 transition-colors">
                <Quote size={80} strokeWidth={1} />
              </div>
              
              <div className="relative z-10">
                <div className="mb-6">
                  <div className="flex gap-1 text-primary mb-2">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="w-4 h-4 fill-current" viewBox="0 0 20 20">
                        <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                      </svg>
                    ))}
                  </div>
                  <RichText
                    html={item.message || ''}
                    className="text-charcoal text-[16px] md:text-[18px] leading-relaxed italic [&_p]:mb-4 max-h-[156px] md:max-h-[176px] overflow-y-auto pr-2 custom-scrollbar"
                  />
                </div>
              </div>

              <div className="flex items-center gap-4 mt-6 pt-6 border-t border-light/50">
                <div className="bg-navy w-12 h-12 rounded-full flex-shrink-0 aspect-square flex items-center justify-center text-white font-bold text-lg">
                  {item.name.charAt(0)}
                </div>
                <div className="min-w-0">
                  <h4 className="font-bold text-navy text-[16px] truncate">{item.name}</h4>
                  <p className="text-[13px] text-gray font-medium truncate">
                    {item.position} 
                  </p>
                  <p className="text-[13px] text-gray font-medium truncate">
                  <span className="text-primary">@ {item.company}</span>
                  </p>
                </div>
              </div>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <div className="flex justify-end gap-3 mt-8">
        <CarouselPrevious className="static translate-y-0 h-12 w-12 border-light text-navy hover:bg-navy hover:text-white" />
        <CarouselNext className="static translate-y-0 h-12 w-12 border-light text-navy hover:bg-navy hover:text-white" />
      </div>
    </Carousel>
  );
}
